<template>
  <v-layout wrap>
    <v-flex xs12 v-if="embedded">
      <v-text-field type="number" box :label="fieldLabel" v-model="value" :disabled="readonly" v-on:blur="blurred()"></v-text-field>
    </v-flex>
    <v-flex xs12 v-else>
      <v-text-field type="number" box :label="fieldLabel" v-model="value" :disabled="readonly" v-on:blur="blurred()"></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import Helpers from "@/helpers.js"

export default {
  name: "number-field",
  props: {
    field: {
      type: Object
    },
    data: {
      type: Number
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  computed: {
    fieldLabel() {
      return this.field.display_name
        ? this.field.display_name
        : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    value: {
      get() {
        if (this.data !== null && this.data !== undefined) {
          return this.data
        } else {
          if (this.field.default_value) {
            return this.field.default_value
          } else {
            return ""
          }
        }
      },
      set(data) {
        this.$emit("update-item", {
          field: this.field.name,
          data: parseFloat(data),
          row: this.row
        })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) {
        readonly = this.field.readonly
      }
      return readonly
    }
  },
  methods: {
    blurred() {
      this.$emit("blurred", {
        field: this.field.name,
        data: this.data,
        row: this.row
      })
    }
  }
}
</script>
